import React from "react";

const Footer = () => {
  return (
    <div className="border-b-0 flex justify-center items-center h-16 drop-shadow-md dark:bg-gray-900 bg-gray-50 border border-x-0 dark:border-t-gray-100 border-t-gray-900">
      <small>Developed by Pranav</small>
    </div>
  );
};

export default Footer;
